import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { logger } from "../utils/logger";
import { useUser } from "./use-user";

export function useAuthB2BRedirect() {
  const { systemUser, sessionUser, userIsLoading } = useUser(false);
  const [isRedirecting, setIsRedirecting] = useState(false);
  const router = useRouter();
  const isLoading = userIsLoading || router.isFallback;

  useEffect(() => {
    if (isLoading || !sessionUser || isRedirecting) {
      return;
    }

    const isFacilitator = !!systemUser?.facilitatedOrganizations?.length;

    if (isFacilitator) {
      setIsRedirecting(true);
      router.push("/hub");
    } else if (!isFacilitator) {
      setIsRedirecting(true);
      router.push("/authentication/signin-organization/no-access");
    } else {
      logger.info("No redirect");
    }
  }, [isLoading, router, systemUser, sessionUser, isRedirecting]);

  return {
    isLoading,
  };
}
